import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Injectable, OnDestroy } from '@angular/core';
import { ILookupTypeList, LookupType } from '../models/lookup-type';
import { BaseRestService } from './base-rest.service';
import { AutoUnsubscribe } from 'auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Injectable({ providedIn: 'root'})
export class LookupTypeService extends BaseRestService<LookupType, ILookupTypeList> implements OnDestroy{
  constructor(http: HttpClient, protected router: Router) {
    super(LookupTypeService, http, 'api/lookuptypes', 'lookuptypes', router);

    // enable caching
    this.cacheEnabled = true;
  }

  ngOnDestroy(): void {
    
  }

  getByDescription(description: string): LookupType{
    const cache = this.getCache();
    const lookupType = cache.find((x) => (x.description.toLowerCase() === description.toLowerCase()));
    return (lookupType) ? lookupType : null;
  }
}
